import JwtService from './jwtService'

//import { store } from '../../redux/store';
// ** Export Service as useJwt
let store;
export const injectStore = _store => {
  store = _store
}
export  function Jwt(jwtOverrideConfig) {
 
  
  const jwt = new JwtService(jwtOverrideConfig, store,null)

  return {
    jwt
  }
}